export enum FormStepLabel {
  BASIC = "Basic",
  MEDIA = "Media",
  LAYOUTS = "Plans",
  LOCATION = "Location",
  ADDITIONAL = "Additional",
  REALTOR = "Realtor",
  PREVIEW = "Preview",
}
